import { ArticleWithImage } from '@/features/editorial/types/editorial-types';

export function formatArticleDate(date: Date | string | undefined, language: string, country: string) {
	if (!date) return null;

	return new Intl.DateTimeFormat(`${language}-${country}`, {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	}).format(new Date(date));
}

export function getHeaderImage(article: ArticleWithImage | undefined | null) {
	const headerImageObj = article?.content.headerImage;

	let url: string | undefined = headerImageObj?.url ?? undefined;

	const mainImageEntityBackdropUrl = article?.content.mainImageEntityBackdrop?.backdropUrl;

	if (!url && mainImageEntityBackdropUrl) url = `${JW_CONFIG.IMAGESCALER_URL}${mainImageEntityBackdropUrl}`;

	return {
		url,
		altText: headerImageObj?.altText,
	};
}
